import {createRoot, hydrateRoot} from 'react-dom/client';
import SingleWineTemplate from '../pages/SingleWineTemplate/SingleWineTemplate'
import "../index.css";
import "../pages/SingleWineTemplate/SingleWineTemplate.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<SingleWineTemplate {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <SingleWineTemplate {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).SingleWineTemplateVC = {mount, hydrate, unmount}